<template>
  <div class="flex flex-col flex-1 min-h-0 min-w-0">
    <FlotoCrudContainer
      ref="list"
      as-table
      :columns="columns"
      :fetch-fn="fetchMyTeam"
      :module-name="moduleName"
      :per-page="100"
      v-bind="$attrs"
      @selection-change="$emit('selection-change', $event)"
    >
      <template v-slot:add-controls="{ refreshList }">
        <FlotoPageHeader>
          <template v-slot:title>
            {{ $tc('my_team', 2) }}
          </template>
        </FlotoPageHeader>
        <MRow class="mt-2 mb-2">
          <MCol>
            <slot name="search" :refresh-list="refreshList">
              <FlotoSearchBar
                :allow-keywords="false"
                :persist-criteria="false"
                :allow-save-search="false"
                :module-name="$constants.USER"
                :exclude-search-params="myTeamExcludeSearchParams"
                @change="applyCriteria($event, refreshList)"
              />
            </slot>
          </MCol>
        </MRow>
      </template>
      <template v-slot:form>
        <span />
      </template>
      <template v-slot:name="{ item }">
        <td class="text-ellipsis">
          <div class="flex items-center">
            <FlotoUserAvatar
              size="small"
              style="min-width: 24px"
              class="mx-1"
              :user-id="item.id"
            />
            {{ item.name }}
          </div>
        </td>
      </template>
      <template v-slot:email="{ item }">
        <td class="text-ellipsis">
          {{ item.email || '---' }}
        </td>
      </template>
      <template v-slot:contactNo="{ item }">
        <td class="text-ellipsis">
          {{ item.contactNo || '---' }}
        </td>
      </template>
      <template v-slot:actions="{ item, edit }">
        <td class="text-ellipsis">
          <div class="flex">
            <DelegateApprovalDrawer :item="item">
              <template v-slot:trigger>
                <MTooltip>
                  <template v-slot:trigger>
                    <a class="mx-1">
                      <MIcon id="delegate-approval-icon" name="user-plus" />
                    </a>
                  </template>
                  {{ $tc('delegate_approval') }}
                </MTooltip>
              </template>
            </DelegateApprovalDrawer>
            <MTooltip v-if="item.userType === 'technician'">
              <template v-slot:trigger>
                <a class="mx-1">
                  <MIcon
                    id="leave-icon"
                    name="calendar-alt"
                    @click="
                      () => (markLeaveDrawerInfo = { technicianId: item.id })
                    "
                  />
                </a>
              </template>
              {{ $tc('mark_leave') }}
            </MTooltip>
          </div>
        </td>
      </template>
      <template v-slot="slotData">
        <slot v-bind="slotData"></slot>
      </template>
    </FlotoCrudContainer>
    <MarkLeaveDrawer
      v-if="markLeaveDrawerInfo"
      technician-is-disabled
      :mark-leave-drawer-info="markLeaveDrawerInfo"
      @cancel="markLeaveDrawerInfo = null"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import { getTeamUsersApi } from '../my-team-api.js'
import CloneDeep from 'lodash/cloneDeep'
import { authComputed, authMethods } from '@state/modules/auth'
import { PreferenceComputed } from '@state/modules/preference'
import DelegateApprovalDrawer from '../components/delegate-approval-drawer'
import { myTeamExcludeSearchParams } from '@components/search/sources'
import MarkLeaveDrawer from '@modules/calendar/components/mark-leave-drawer'
export default {
  name: 'MyTeam',
  components: { DelegateApprovalDrawer, MarkLeaveDrawer },
  data() {
    this.moduleName = this.$constants.MY_TEAM
    this.myTeamExcludeSearchParams = myTeamExcludeSearchParams
    this.columns = [
      {
        name: this.$t('name'),
        key: 'name',
        minWidth: '200px',
        class: 'resource-link',
      },
      {
        name: this.$tc('email'),
        key: 'email',
        width: '200px',
        minWidth: '100px',
      },
      {
        name: this.$tc('contact_no'),
        key: 'contactNo',
        width: '200px',
        minWidth: '100px',
      },
      {
        name: this.$tc('action', 2),
        key: 'actions',
        width: '200px',
        minWidth: '100px',
      },
    ]
    return {
      searchCriterias: {
        quals: [],
      },
      markLeaveDrawerInfo: null,
    }
  },
  computed: {
    ...authComputed,
    ...PreferenceComputed,
    getAllUsers() {
      return (
        this.myAllowedModules.indexOf('admin.users') >= 0 ||
        this.user.superAdminRole
      )
    },
  },
  created() {
    if (
      !(
        this.user.superAdminRole ||
        this.myAllowedModules.indexOf('admin.users') >= 0 ||
        this.user.allowDelegateApprovalTeam
      )
    ) {
      return this.$router.replace({ name: '404' })
    }
  },
  methods: {
    ...authMethods,
    applyCriteria(searchCriteria, refreshList) {
      this.searchCriterias = searchCriteria
      refreshList()
    },
    fetchMyTeam(limit, offset) {
      const criterias = CloneDeep(this.searchCriterias)
      let filters = {}
      if (this.user) {
        filters.id = this.user.id
      }
      return getTeamUsersApi(
        this.getAllUsers ? {} : filters,
        criterias,
        limit,
        offset
      )
    },
    refresh() {
      this.$refs.list.refresh()
    },
  },
}
</script>
